import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const useEditFormCancel = (backTo, isDirty = false) => {
  const navigate = useNavigate();

  return useCallback(async () => {
    if (isDirty) {
      const result = await Swal.fire({
        title: 'Discard changes?',
        text: 'You have unsaved changes. Are you sure you want to leave?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, leave',
        cancelButtonText: 'Keep editing',
        confirmButtonColor: '#2c82d8',
      });

      if (!result.isConfirmed) {
        return;
      }
    }

    navigate(backTo);
  }, [backTo, isDirty, navigate]);
};

export default useEditFormCancel;
